import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setError('');
    setLoading(true);

    // Basic email validation
    if (!email || !password) {
      setError('Please enter both email and password');
      setLoading(false);
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address');
      setLoading(false);
      return;
    }

    const payload = { email, password };

    try {
      const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(payload),
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Response Data:", data);

        // Check if the server response indicates a successful login
        const setUserData = (role) => {
          localStorage.setItem('isAuthenticated', 'true');
          localStorage.setItem('email', email);
          localStorage.setItem('role', role);
          localStorage.setItem('userId', data.user_id);
          localStorage.setItem('userName', data.user_name);
          navigate('/');
        };

        switch (data.status) {
          case 'admin':
          case 'user':
          case 'employee':
          case 'manager':
          case 'sale manager':
            setUserData(data.status);
            break;
          default:
            setError('Invalid email or password');
            break;
        }
      } else {
        const errorData = await response.json();
        console.log('Error Response:', errorData);
        setError(`API error: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      setError(`Invalid Credentials`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <Card style={{ width: '34rem' }}>
        <Card.Body>
          <div className="text-center mb-4">
            <img
              src="https://aksharafinalytics.com/wp-content/uploads/elementor/thumbs/akfin-qgepick2gc4b4m3xfynr658qlgki21rx8vyqzuu9ys.png"
              alt="Logo"
              style={{ width: '250px', height: 'auto' }}
            />
          </div>

          {/* Display error message */}
          {error && <Alert variant="danger">{error}</Alert>}

          <Form>
            <Form.Group controlId="email" className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId="password" className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            {/* Login Button */}
            <Button variant="primary" className="w-100" onClick={handleLogin} disabled={loading}>
              {loading ? (
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
              ) : null}
              {loading ? 'Logging in...' : 'Login'}
            </Button>

            {/* Registration Link */}
            <div className="mt-3 text-center">
              <p>
                Don't have an account? <Link to="/Register">Register here</Link>
              </p>
              <p>
                Forgot Password? <Link to="/EmailVerify">Click here</Link>
              </p>
              
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default Login;
